export default __webpack_public_path__ + "static/media/post.3baea8d6.png";